import React from 'react';
import { Users } from 'lucide-react';

const ExternalPartners = () => {
  return (
    <section className="external-partners-section">
      <div className="external-partners-container">
        <div className="partners-icon-wrapper">
          <Users className="partners-icon" />
        </div>
        <h3 className="partners-title">Red de Colaboración Profesional</h3>
        <p className="partners-description">
          Contamos con una red de socios externos altamente especializados en distintas 
          áreas del Derecho, lo que nos permite brindarte asesoramiento integral y 
          soluciones completas para cada situación legal que necesites resolver.
        </p>
      </div>
    </section>
  );
};

export default ExternalPartners;